var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KYCRequestsList',{attrs:{"kyc-requests":_vm.pendingKYCRequests,"is-loading":_vm.isLoading},on:{"change-auto-reload":_vm.onChangeAutoReload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }